import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const prefixUserList = 'configuration.users.list'
const translateHeaderPrefix = `${prefixUserList}.headers`

export const usePermissionsList = () => {
  const { t } = useTranslation()

  const permissionsList = useMemo(
    () => [
      { label: t(`${translateHeaderPrefix}.role.admin`), value: 1 },
      { label: t(`${translateHeaderPrefix}.role.moderator`), value: 2 },
      { label: t(`${translateHeaderPrefix}.role.supervisor`), value: 5 },
    ],
    [t]
  )

  return permissionsList
}
